import React from "react";
import { Link } from "react-router-dom";

const Bio = () => {
    return (
        <div className="wrapper wf section">
            <div className="section-left section-long">
                <div className="content">
                    <img
                        src="thepicture.jpeg"
                        alt="Mile Ristov"
                        className="profile-img"
                    />
                    <div className="header-mask">
                        <h1 className="header header-large align-left">
                            About
                        </h1>
                    </div>
                    <p className="description-static description-long">
                        <span className="quote">
                            I'm Mile, Front-End Developer.
                            <br />
                        </span>
                        <br />
                        I am a Front-End Developer based in Stuttgart, Germany
                        with a passion for creating innovative web applications.
                        My journey into the world of coding began in February
                        2022 and since then, I have made rapid progress in my
                        skills. I achieved this through attending Spiced
                        Academy's 12-week intensive bootcamp, where I worked on
                        multiple projects and gained proficiency in a range of
                        valuable technologies, including JavaScript, React, CSS,
                        HTML, PostgreSQL, Node.js, and AWS S3.
                        <br />
                        After finishing the bootcamp, I dedicated my time to
                        building my portfolio and further improving my skills,
                        seeking out new challenges to improve my craft.
                        <br />
                        <br />
                        <a
                            href="https://github.com/Mileristov"
                            target="_blank"
                            rel="noreferrer"
                            className="link-blue"
                        >
                            My Github
                        </a>
                        <br />
                        <br />
                        - Steve Jobs
                        <br />
                        <br />
                        <span className="quote">
                            "The only way to do great work is to love what you
                            do."
                        </span>
                        <br />
                        My current focus is on developing my skills through
                        independent projects and helping friends with their own.
                        If you have a project you'd like to work on together,
                        please don't hesitate to get in touch.
                        <br />
                        <br />
                        <span className="header">
                            <br />
                            My Current Stack
                        </span>
                        <br />
                        HTML / CSS / Javascript / React / NEXT.js / Node.js /
                        PostgreSQL / Framer Motion /
                        <br />
                        <br />
                        <br />
                        <a
                            href="CV_Mile_Ristov_Frontend_Developer.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="button w-button"
                        >
                            My CV
                        </a>
                        <br />
                        <br />
                        Beyond my coding work, I enjoy catching up with friends
                        and family, staying up-to-date on the latest NBA
                        content, and discovering new coffee shops in my area.
                        <br />
                        <br />
                    </p>
                </div>
                <Link to="/contact" class="button w-button">
                    Contact me
                </Link>
            </div>
        </div>
    );
};

export default Bio;
